<div class="modal-header">
  <h3 class="modal-title">Edit Data</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (!dataLoaded) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (dataLoaded) {
<form #countryForm="ngForm">
    <div class="form-group">
      <label class="form-label">Tax Residence</label>
      <select class="form-control" name="taxResidence" [ngModel]="request.taxResidenceId" (ngModelChange)="onTaxResidenceChange($event)">
        <option [ngValue]="null" disabled>Select Tax Residence</option>
        @for (item of taxResidenceCountries; track $index) {
<option [ngValue]="item.value">{{item.label}}</option>
}
      </select>
    </div>
    <div class="form-group">
      <label class="form-label">Countries</label>
      <select class="form-control" name="country" [ngModel]="request.countryId" (ngModelChange)="onCountryChange($event)">
        <option [ngValue]="null" disabled>Select Country</option>
        @for (item of countries; track $index) {
<option [ngValue]="item.value">{{item.label}}</option>
}
      </select>
    </div>
    <div class="form-group">
      <label class="form-label">CbyC TIN</label>
      <input class="form-control" type="text" [(ngModel)]="request.tin" name="tin" />
    </div>
    <div class="form-group">
      <label class="form-label">LE Name</label>
      <input class="form-control" type="text" [(ngModel)]="request.leName" name="leName" />
    </div>
  </form>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="updateCountry()">Update</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
